/* ============================================================
   c_carousel-controls.js — 共通カルーセル操作UI driver
   .c-carousel-controls ごとに、同じ親要素内の row(data-carousel-row) を探し、
   スクロール量・進捗バー・前後ボタンの disable・(任意)is-hidden を制御する。
   旧 c_featured-products / c_category-grid / c_featured-artisans の重複JSを集約。
   ============================================================ */
(function () {
  function initOne(controls) {
    if (controls.dataset.ccInit) return;
    var parent = controls.parentElement;
    if (!parent) return;
    var row = parent.querySelector(controls.getAttribute('data-carousel-row'));
    if (!row) return;
    controls.dataset.ccInit = '1';

    var prev = controls.querySelector('.c-carousel__arrow--prev');
    var next = controls.querySelector('.c-carousel__arrow--next');
    var fill = controls.querySelector('.c-carousel__progress-fill');
    var autohide = controls.classList.contains('c-carousel-controls--autohide');
    var cardSel = controls.getAttribute('data-carousel-card');
    var fallback = parseInt(controls.getAttribute('data-carousel-fallback'), 10) || 300;
    var gap = parseInt(controls.getAttribute('data-carousel-gap'), 10) || 20;

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var pos = row.scrollLeft;
      if (autohide) controls.classList.toggle('is-hidden', max <= 0);
      if (fill) fill.style.width = max > 0 ? (pos / max * 100) + '%' : '0%';
      if (prev) prev.disabled = pos <= 0;
      if (next) next.disabled = pos >= max - 1;
    }

    controls.querySelectorAll('.c-carousel__arrow').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var dir = parseInt(arrow.getAttribute('data-scroll-dir'), 10) || 1;
        var card = cardSel ? row.querySelector(cardSel) : null;
        var cardWidth = card ? card.offsetWidth : fallback;
        row.scrollBy({ left: (cardWidth + gap) * dir, behavior: 'smooth' });
      });
    });

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('cc:refresh', update);
    update();
  }

  function run() {
    document.querySelectorAll('.c-carousel-controls').forEach(initOne);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  // タブ切替や、テーマエディタでのセクション再描画にも追従
  document.addEventListener('shopify:section:load', run);
})();
